import React, { Component } from "react";
import { Route } from "react-router-dom";
// eslint-disable-next-line no-unused-vars
import Car from "./Car";
import CreditRisk from "./CreditRisk";
import SystemStats from "./SystemStats";

export default function Dashboard({ match }) {
  return (
    <div className="content">
      <div className="container-fluid">
        <Route exact path={`${match.url}`} component={SystemStats} />
        <Route path={`${match.url}/stats`} component={SystemStats} />
        <Route path={`${match.url}/car`} component={Car} />
        <Route path={`${match.url}/credit-risk`} component={CreditRisk} />
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// src/pages/Dashboard/index.js